<template>
  <div>
    <label for="text">
      Insurance Name
      <span class="star">*</span>
    </label>
    <el-select
      v-model="payor.payor"
      filterable
      remote
      reserve-keyword
      clearable
      placeholder="Enter Insurance Name"
      :remote-method="getAutoCompletePayorsData"
      @change="handleSelect"
      @blur="handleBlur"
      :loading="payorsLoading"
    >
      <el-option
        v-for="(item, index) in getAllPayorsIncludeCurrentPayor || []"
        :key="index"
        :label="item.insurance_name"
        :value="item.insurance_name"
      ></el-option>
    </el-select>
    <p class="error" v-if="validataionErrors && validataionErrors[getErrorKey]">
      {{ validataionErrors[getErrorKey] }}
    </p>
    <p class="error" v-if="billToSelf">Please select the Insurance Name</p>
    <!-- Missing Insurance Dialog -->
    <div class="default-modal">
      <el-dialog
        v-model="showInsuranceDialog"
        width="45%"
        :before-close="handleDialogClose"
      >
        <div class="dialog-header">
          <span class="header-part"> Missing Insurance Details </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handleDialogClose"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date pb-0">
          <p class="popup-content">
            The insurance name you entered is not currently available in our
            system. <br />
            Please add the insurance name below and upload a copy of the
            insurance card or supporting document.
          </p>
          <div class="inner-fields">
            <div class="each-block">
              <label> Enter Insurance Name <span class="star">*</span> </label>
              <p>
                (Required - please enter the exact name as shown on the
                insurance card)
              </p>
              <el-input
                v-model="newInsuranceName"
                placeholder="Enter full insurance name"
                clearable
              />
            </div>
            <div class="each-block pb-0">
              <label>
                Upload Insurance Document <span class="star">*</span>
              </label>
              <p>(Required - please upload a valid copy for verification)</p>
              <el-upload
                name="logo"
                action
                :on-change="uploadFile"
                :show-file-list="false"
                :auto-upload="false"
              >
                <el-button
                  class="btn radius-button round-button"
                  style="display: flex; align-items: center; margin-top: 5px"
                >
                  <img
                    src="@/assets/images/icons/attachment-icon-v2.svg"
                    alt="Attach"
                    style="width: 16px; height: 16px"
                  />
                  Upload
                </el-button>
              </el-upload>
            </div>
          </div>

          <span v-if="selectedFile" style="font-size: 14px; margin-top: 6px">
            File: {{ selectedFile.name }}
          </span>
          <p class="error" v-if="showValidationError">
            {{ errorValidationMessage }}
          </p>
        </div>
        <div class="dialog-footer">
          <el-button class="cancel-button" @click="handleDialogClose"
            >Cancel</el-button
          >
          <el-button
            class="blue-save-button"
            type="primary"
            @click="confirmMissingInsurance"
            >Save</el-button
          >
        </div>
      </el-dialog>
    </div>

    <div class="default-modal" v-if="billToSelf">
      <el-dialog
        width="30%"
        top="15%"
        v-model="showBillToSelfDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="dialog-header">
          <span class="header-part">Warning</span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="showBillToSelfDialog = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date">
          <span class="description" style="word-break: auto-phrase">
            "When “Bill To” is Insurance, Insurance Name cannot be Self. To set
            Insurance Name as Self, change “Bill To” to Patient or Client".
          </span>
        </div>
        <div class="dialog-footer" style="padding-right: 20px">
          <el-button
            class="cancel-button"
            @click="
              (showBillToSelfDialog = false), getAllPayorsIncludeCurrentPayor
            "
            >Ok</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "payorData",
    "validataionErrors",
    "insuranceType",
    "clearPayor",
    "billTo",
    "billToInsurance",
  ],
  data() {
    return {
      payorsLoading: false,
      payor: "",
      includeCurrentPayor: true,
      searchQuery: "",
      searchTriggeredEmptyResult: false, // track if no data found
      showInsuranceDialog: false,
      newInsuranceName: "",
      selectedFile: null,
      showValidationError: false,
      billToSelf: false,
      showBillToSelfDialog: false,
    };
  },
  computed: {
    ...mapGetters("payors", ["getAllPayors"]),
    errorValidationMessage() {
      if (!this.newInsuranceName.trim() && !this.selectedFile) {
        return "Please enter insurance name and upload document.";
      } else if (!this.newInsuranceName.trim()) {
        return "Please enter insurance name.";
      } else if (!this.selectedFile) {
        return "Please upload insurance document.";
      }
      return "";
    },
    getAllPayorsIncludeCurrentPayor() {
      return this.includeCurrentPayor
        ? [this.payorData]
        : this.getAllPayors?.data || [];
    },
    getErrorKey() {
      return `insurance.${this.insuranceType}.payor`;
    },
  },
  mounted() {
    this.payor = this.payorData;
    if (
      (this.payorData.payor === "SELFPAY" ||
        this.payorData.payor === "- self pay" ||
        this.payorData.payor === "Self Pay") &&
      this.billToInsurance &&
      this.billToInsurance == "INSURANCE"
    ) {
      this.billToSelf = true;
      this.showBillToSelfDialog = true;
      this.payor.payor = "";
      this.payor.insurance_carrier_code = "";
      this.payor.policy_id = "";
      this.includeCurrentPayor = true;
      return;
    }
  },
  methods: {
    async getAutoCompletePayorsData(queryString) {
      this.includeCurrentPayor = false;
      this.searchQuery = queryString;
      this.payorsLoading = true;

      if (queryString?.length > 1) {
        await this.$store.dispatch("payors/fetchAllPayors", {
          search_string: queryString,
          page: 1,
          limit: 10,
        });

        const matched = this.getAllPayors?.data?.length || 0;
        this.searchTriggeredEmptyResult = matched === 0;
        if (matched === 0 && !this.isUserLab) {
          this.showInsuranceDialog = true;
          this.newInsuranceName = queryString;
          this.showValidationError = false;
        }
      }

      this.payorsLoading = false;
    },
    clearData() {
      this.payor.payor = "";
      this.payor.insurance_carrier_code = "";
      this.payor.policy_id = "";
    },
    
    handleSelect(data) {
      this.billToSelf = false;
      if (
        data === "Self Pay" &&
        this.billToInsurance &&
        this.billToInsurance == "INSURANCE"
      ) {
        this.billToSelf = true;
        this.showBillToSelfDialog = true;
        this.payor.payor = "";
        this.payor.insurance_carrier_code = "";
        this.payor.policy_id = "";
        this.includeCurrentPayor = true;
        return;
      }
      const selectedPayor = this.getAllPayorsIncludeCurrentPayor.find(
        (item) => item.insurance_name === data
      );
      console.log("Change Data :: ", data , selectedPayor)
      this.$emit("payorSelect", selectedPayor);
      this.searchTriggeredEmptyResult = false;
    },
    // setSelfPay() {
    //   const selfPayMap = {
    //     PATIENT: "Self Pay",
    //     CLIENT: "Client Bill",
    //     LABCORP: "Send out",
    //   };
    //   if (selfPayMap[this.billTo]) {
    //     this.payor.payor = selfPayMap[this.billTo];
    //     this.$emit("payorSelect", {
    //       name: selfPayMap[this.billTo],
    //       payor_electronic_id: selfPayMap[this.billTo],
    //     });
    //   }
    // },
    handleBlur() {
      if (
        this.searchTriggeredEmptyResult &&
        this.searchQuery &&
        !this.payor?.payor
      ) {
        if (!this.isUserLab) {
          this.showInsuranceDialog = true;
        }
        this.newInsuranceName = this.searchQuery;
        this.showValidationError = false;
      }
    },
    handleDialogClose() {
      this.showInsuranceDialog = false;
      this.newInsuranceName = "";
      this.selectedFile = null;
      this.showValidationError = false;
    },
    confirmMissingInsurance() {
      if (this.newInsuranceName.trim() && this.selectedFile) {
        this.payor.payor = this.newInsuranceName.trim();

        const insuranceData = {
          name: this.newInsuranceName.trim(),
          file: this.selectedFile,
        };
        this.$emit("newInsuranceNameDetails", insuranceData);
        this.handleDialogClose();
      } else {
        this.showValidationError = true;
      }
    },
    uploadFile(file) {
      this.selectedFile = file.raw;
      this.showValidationError = false;
    },
  },
  watch: {
    clearPayor: {
      immediate: true,
      deep: true,
      handler: function () {
        if (this.clearPayor) {
          this.payor.payor = "";
          this.payor.insurance_carrier_code = "";
          this.payor.policy_id = "";
        }
        this.payor = this.payorData;
        // if (
        //   this.billTo == "PATIENT" ||
        //   this.billTo == "CLIENT" ||
        //   this.billTo == "LABCORP"
        // ) {
        //   this.setSelfPay();
        // } else {
        //   this.payor = this.payorData;
        // }
      },
    },
    payorData: {
      immediate: true,
      handler(newData) {
        this.payor = { ...newData };
      },
    },
    billTo: {
      immediate: true,
      deep: true,
      handler() {
        if (this.billTo === "INSURANCE") {
          this.payor = this.payorData;
        }
        //  else if (["PATIENT", "CLIENT", "LABCORP"].includes(this.billTo)) {
        //   this.setSelfPay();
        // }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  margin-top: 2px !important;
  color: #ed5d5d;
  font-size: 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
}

.star {
  color: red;
}

.popup-content {
  font-size: 14px;
  padding-bottom: 1rem;
  color: #05af3d;
  line-height: 20px;
  word-break: break-word;
}
.inner-fields {
  .each-block {
    padding-bottom: 1rem;
    label {
      font-size: 14px;
    }
    p {
      margin: 0;
      font-size: 12px;
    }
  }
}
</style>

